module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 18.5 15.1\" enable-background=\"new 0 0 18.5 15.1\" xml:space=\"preserve\"><polygon class=\"control-svg\" points=\"9.6,0 4.3,4.2 0,4.2 0,10.9 4.3,10.9 9.6,15.1 \"></polygon><g><path class=\"control-svg\" d=\"M18.4,4.4l-2.1,3.1l2.2,3.3h-1.3l-1.1-1.5c-0.2-0.3-0.4-0.6-0.6-1.1l0,0c-0.2,0.3-0.4,0.7-0.6,1.1l-1,1.5 h-1.4l2.2-3.3l-2.1-3.1H14l0.9,1.4c0.2,0.3,0.4,0.6,0.6,1.1l0,0c0.2-0.4,0.4-0.7,0.6-1.1l1-1.4H18.4z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/icons/muted.svg
// module id = 895
// module chunks = asvp